function exchange_b64img(type, b64img) {
    let img_str = '';

    if (['svg', 'svg+xml'].includes(type)) {
        img_str = 'data:image/svg+xml;base64'

    } else if (type === 'png') {
        img_str = 'data:image/png;base64'

    } else if (type === 'gif') {
        img_str = 'data:image/gif;base64'

    } else if (type === 'ico') {
        img_str = 'data:image/x-icon;base64'

    } else {
        img_str = 'data:image/jpeg;base64';

    }

    return img_str + ',' + b64img;
}

function randomStr(length) {
    let result           = '';
    let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
}

function getB64Image(event, max_width, max_height, callback) {
    const files = event.target.files || event.dataTransfer.files;
    if (!files.length) return;

    const MAX_WIDTH = max_width;
    const MAX_HEIGHT = max_height;
    const b64ImgFile = files[0];
    const b64ImgType = b64ImgFile.type.split('/')[1];
    const reader = new FileReader();
    let b64Img = null;

    reader.onload = (e) => {
        let img = document.createElement("img");

        img.onload = (_e) => {
            let width = img.width;
            let height = img.height;

            // Change the resizing logic
            if (width > height) {
                if (width > MAX_WIDTH) {
                    height = height * (MAX_WIDTH / width);
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width = width * (MAX_HEIGHT / height);
                    height = MAX_HEIGHT;
                }
            }

            // Dynamically create a canvas element
            let canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;

            // var canvas = document.getElementById("canvas");
            let ctx = canvas.getContext("2d");

            // Actual resizing
            ctx.drawImage(img, 0, 0, width, height);

            // Show resized image in preview element
            // let dataurl = canvas.toDataURL(this.OSTemplateImage.b64ImgType);

            b64Img = canvas.toDataURL(b64ImgType);
            // return b64Img;
            callback(b64Img, b64ImgType);
        }

        img.src = e.target.result;
        // this.OSTemplateImage.b64Img = e.target.result;
    };

    // reader.readAsBinaryString(b64ImgFile);
    reader.readAsDataURL(b64ImgFile);
}

function getContrastColor(rgb) {
    let pureRGB = rgb.replace('#', '');
    let ruler = 255;
    let balance = 136;
    let red = parseInt(pureRGB.substr(0, 2), 16) + balance;
    let green = parseInt(pureRGB.substr(2, 2), 16) + balance;
    let blue = parseInt(pureRGB.substr(4, 2), 16) + balance;
    let contrastRed = red < ruler ? red : red - ruler;
    let contrastGreen = green < ruler ? ruler : green - ruler;
    let contrastBlue = blue < ruler ? blue : blue - ruler;
    let contrastRGB = (contrastRed).toString(16) + (contrastGreen).toString(16) + (contrastBlue).toString(16);
    return '#' + contrastRGB;
}

function getContrastColorBW(rgb) {
    let pureRGB = rgb.replace('#', '');
    let intRGB = parseInt(pureRGB, 16);
    let balanceRGB = parseInt('cccccc', 16);
    let black = '#2b2b2b';
    let white = '#ffffff';

    if (intRGB < balanceRGB) {
        return white;
    } else {
        return black;
    }
}

function arrayToCsv(data){
  return data.map(row =>
    row
    .map(String)  // convert every value to String
    .map(v => v.replaceAll('"', '""'))  // escape double colons
    .map(v => `"${v}"`)  // quote it
    .join(',')  // comma-separated
  ).join('\r\n');  // rows starting on new lines
}

function downloadByBlob(content, filename, contentType) {
  // Create a blob
  let blob = new Blob([content], { type: contentType });
  let url = URL.createObjectURL(blob);

  // Create a link to download it
  let pom = document.createElement('a');
  pom.href = url;
  pom.setAttribute('download', filename);
  pom.click();
}

function bandwidthHumanReadable(bandwidth) {
    let HumanReadable = 0;
    if (bandwidth === 0) {
        HumanReadable = 0;
    }
    else if (bandwidth < 1000 ** 2) {
        HumanReadable = bandwidth / 1000 + ' Kbps';
    }
    else if (1000 ** 2 <= bandwidth && bandwidth < 1000 ** 3) {
        HumanReadable = bandwidth / 1000 ** 2 + ' Mbps';
    }
    else {
        HumanReadable = bandwidth / 1000 ** 3 + ' Gbps';
    }

    return HumanReadable;
}

function prettyBps(bits, decimals) {
    const sizes = ['Bps', 'Kbps', 'Mbps', 'Gbps', 'Tbps', 'Pbps'];
    const dm = decimals != null && !isNaN(decimals) && decimals >= 0 ? decimals : 2;
    let i = Math.floor(Math.log(bits) / Math.log(1000));

    return parseFloat((bits / Math.pow(1000, i)).toFixed(dm)) + ' ' + sizes[i];
}

function formatVideoDevice(video_device) {
    let video_device_ = '';
    let origin_video_device = video_device.toLowerCase()

    if (origin_video_device === 'qxl') {
        video_device_ = 'QXL';
    } else if (origin_video_device === 'vga') {
        video_device_ = 'VGA';
    } else if (origin_video_device === 'virtio') {
        video_device_ = 'Virtio';
    } else if (origin_video_device === 'cirrus') {
        video_device_ = 'Cirrus';
    } else if (origin_video_device === 'none') {
        video_device_ = 'None';
    } else {
        video_device_ = video_device;
    }

    return video_device_;
}

export {
    exchange_b64img,
    randomStr,
    getB64Image,
    getContrastColor,
    getContrastColorBW,
    arrayToCsv,
    downloadByBlob,
    bandwidthHumanReadable,
    prettyBps,
    formatVideoDevice,
}
